import './Logo.css'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { useThemeContext } from '../../../../../contexts'

export const Logo: React.FC = () => {
  const { t } = useTranslation()
  const { theme } = useThemeContext()
  const isEnabled = theme?.Logo?.IsEnabled && theme?.IsEnabled
  const logo = theme?.Logo?.Value

  return (
    <Link to="/">
      <img
        src={isEnabled && logo ? logo : '/assets/images/logo-joubini.png'}
        alt={t('common.logo.placeholderText')}
        className="header__logo"
      />
    </Link>
  )
}
